import { LoadingMask, Paragraph, Table } from '@zillow/constellation-10';
import { useCompetitorsWithSpecialOffer, useNewInventory, useTopNewConstructions } from './MarketDataMap.utils';
import { DisplayingRegionLevel } from '../../../../types/DisplayingRegionLevel';
import { roundUp } from '../../../../utils/roundUp';
import { TopConstructionStatus } from '@zg-rentals/ts-customer-analytics-client';

export const CompetitorsSidebarTable = ({ finalDisplayMode }: { finalDisplayMode: DisplayingRegionLevel }) => {
  const { data: newInventory, isLoading: isLoadingNewInventory } = useNewInventory(
    finalDisplayMode === DisplayingRegionLevel.ZIP,
  );

  const { data: topNewConstructions, isLoading: isLoadingTopNewConstructions } = useTopNewConstructions(
    finalDisplayMode === DisplayingRegionLevel.ZIP,
  );

  const { data: competitorsWithSpecialOffer, isLoading: isLoadingCompetitorsWithSpecialOffer } =
    useCompetitorsWithSpecialOffer(finalDisplayMode === DisplayingRegionLevel.ZIP);

  const totalBuildings =
    (newInventory?.length ?? 0) + (topNewConstructions?.length ?? 0) + (competitorsWithSpecialOffer?.length ?? 0) || 0;

  const haveSpecialOfferBuildingsCount =
    (topNewConstructions?.filter((building) => building.specialOffer).length ?? 0) +
    (competitorsWithSpecialOffer?.length ?? 0);

  const addedInventoryToZillowRentalsNetworkCount = newInventory?.length ?? 0;

  const completedConstructionCount =
    topNewConstructions?.filter((building) => building.constructionStatus === TopConstructionStatus.COMPLETE).length ??
    0;

  return (
    <LoadingMask
      loading={isLoadingNewInventory || isLoadingTopNewConstructions || isLoadingCompetitorsWithSpecialOffer}
      css={{ width: '100%', '& > div': { width: '100%' } }}
    >
      <Table.Root aria-label="Market data table">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Competitor activity</Table.HeaderCell>
            <Table.HeaderCell css={{ textAlign: 'right' }}>% of buildings</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Have a special offer</Table.Cell>
            <Table.Cell>
              <Paragraph css={{ textAlign: 'right' }}>
                {totalBuildings > 0
                  ? roundUp((haveSpecialOfferBuildingsCount / totalBuildings) * 100, 1).toFixed(1)
                  : '0.0'}
                %
              </Paragraph>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Added inventory to the Zillow Rentals Network</Table.Cell>
            <Table.Cell>
              <Paragraph css={{ textAlign: 'right' }}>
                {totalBuildings > 0
                  ? roundUp((addedInventoryToZillowRentalsNetworkCount / totalBuildings) * 100, 1).toFixed(1)
                  : '0.0'}
                %
              </Paragraph>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Completed construction</Table.Cell>
            <Table.Cell>
              <Paragraph css={{ textAlign: 'right' }}>
                {totalBuildings > 0
                  ? roundUp((completedConstructionCount / totalBuildings) * 100, 1).toFixed(1)
                  : '0.0'}
                %
              </Paragraph>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
    </LoadingMask>
  );
};
